import { IMenuRouteInfo } from '@nimbus-library/features/menu';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';

// noinspection JSUnusedGlobalSymbols
export enum RoutesIds {
  Provisioning = 'provisioning',
  Dashboard = 'dashboard',
  Dashboards = 'dashboards',
  Reporting = 'reporting',
  Workflow = 'workflow',
  Settings = 'settings',
  Manage = 'manage',
  Brand = 'brand',
  Personal = 'personal',
  PersonalMyTeams = 'personalTeams',
  PersonalAttendantConsole = 'personalAttendantconsole',
  PersonalMySessions = 'personalMySessions',
  PersonalOverview = 'personalOverview',
  UserPreferences = 'userPreferences',
  PersonalHistoricalSessions = 'teamSessions',
  PersonalVoicemails = 'personalVoicemails',
  TaskFlowVisualizer = 'taskFlowVisualizer',
  CustomerInsights = 'customerInsights',
  CompanionConversation = 'companionConversation',
}

type IRouteIdModels = { [key in RoutesIds]: IMenuRouteInfo };

export const Routes: IRouteIdModels = {
  brand: { name: 'Luware Ltd.' },
  dashboard: { name: TranslationKeys.MenuLiveView, path: '/live-view' },
  dashboards: { name: TranslationKeys.MenuDashboards, path: '/dashboards' },
  customerInsights: { name: TranslationKeys.MenuCustomerInsights, path: '/customer-overview/customer-insights' },
  personal: { name: TranslationKeys.MenuPersonalServicesOverview },
  personalAttendantconsole: { name: TranslationKeys.MenuPersonalAttendantconsole, path: '/personal/attendantconsole' },
  personalMySessions: { name: TranslationKeys.MenuPersonalMySessions, path: '/personal/my-sessions' },
  personalOverview: { name: TranslationKeys.MenuPersonalOverview, path: '/personal/overview' },
  personalTeams: { name: TranslationKeys.MenuPersonalServicesOverview, path: '/personal/services-overview' },
  teamSessions: { name: TranslationKeys.MenuSessionsList, path: '/sessions-list' },
  personalVoicemails: { name: TranslationKeys.MenuVoicemails, path: '/personal/voicemails' },
  provisioning: { name: TranslationKeys.MenuProvisioning, path: '/provisioning' },
  reporting: { name: TranslationKeys.MenuStatistics, path: '/statistics' },
  settings: { name: TranslationKeys.MenuSettings, path: '/settings' },
  taskFlowVisualizer: { name: TranslationKeys.MenuTaskFlowVisualizer, path: '/task-flow-visualizer' },
  workflow: { name: TranslationKeys.MenuWorkflow, path: '/workflow' },
  manage: { name: TranslationKeys.ManageTitle, path: '/manage' },
  userPreferences: { name: TranslationKeys.UserPreferencesTitle, path: '/user-preferences' },
  companionConversation: { name: TranslationKeys.CompanionChatPageTitle, path: '/companion-chat' },
};
